import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

declare function privacy(): any;
@Component({
    selector: 'prof-onetrust-privacy-policy',
    templateUrl: './onetrust-privacy-policy.component.html',
    styleUrl: './onetrust-privacy-policy.component.scss',
    standalone: false
})
export class OnetrustPrivacyPolicyComponent implements OnInit {

  constructor(private _translateService: TranslateService) {}
  title: string;
  private onDestroy$ = new Subject<void>();
  ngOnInit(): void {
    this._translateService
          .get('ONETRUST.privacy_policy')
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(value => (this.title = value));
    privacy();
  }

}
